import { render, staticRenderFns } from "./PassportSvg.vue?vue&type=template&id=598f3b9a&"
import script from "./PassportSvg.vue?vue&type=script&lang=ts&"
export * from "./PassportSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports